import React from 'react';
import { lazy } from 'react-loosely-lazy';
import { ExperienceErrorBoundary } from '@atlassian/jira-business-experience-tracking';
import Placeholder from '@atlassian/jira-placeholder';
import { VIEW_RELEASE_EXPERIENCE } from '../../../../common/constants';
import type { Props } from './main';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const CalendarReleasePopup = lazy(
	() => import(/* webpackChunkName: "async-jwm-calendar-release-popup" */ './main'),
);

const AsyncCalendarReleasePopup = (props: Props) => (
	<ExperienceErrorBoundary experience={VIEW_RELEASE_EXPERIENCE} fallback="flag">
		<Placeholder name="calendar-release-popup" fallback={null}>
			<CalendarReleasePopup {...props} />
		</Placeholder>
	</ExperienceErrorBoundary>
);

export default AsyncCalendarReleasePopup;
